import { render, staticRenderFns } from "./deletePrinterRuleMachine.vue?vue&type=template&id=20c7444a&scoped=true"
import script from "./deletePrinterRuleMachine.vue?vue&type=script&lang=js"
export * from "./deletePrinterRuleMachine.vue?vue&type=script&lang=js"
import style0 from "./deletePrinterRuleMachine.vue?vue&type=style&index=0&id=20c7444a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7444a",
  null
  
)

export default component.exports